// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_Bjy2o40P","iconContainer":"iconContainer_mWVoY6b_","label":"label_ghyLowLx","linkLabel":"linkLabel_rsQ_xDkg"};